import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
import createLogger from 'vuex/dist/logger'; // eslint-disable-line

export default function (debug) {
  var plugins = [];

  if (debug) {
    var devPlugins = [];

    if (process.browser) {
      devPlugins.push(createLogger());
    }

    plugins = devPlugins;
  } else {
    plugins = plugins.concat([]);
  }

  return plugins;
}